// extracted by mini-css-extract-plugin
export default {"container":"wSCA1BYmishgCG554j9P","gradientText":"EG4KbABxguB5UzglJPiK","h1Text":"RTXB93N4kXMf_ZvW6zHs","bodyText":"tTvybixzlrwBqov4jub3","lightningImage":"plKiUWRS4bH3L6rrNCGE"};